import { PropsWithChildren } from 'react'
import * as S from './styled'

type PricingItem = {
    id: string
    title: string
    price: string
    descriptionList: string[]
}

const pricingList: PricingItem[] = [
    {
        id: '1',
        title: 'Basic',
        price: '5000',
        descriptionList: [
            'Single-page',
            'Pro malé firmy, OSVČ i jednotlivce',
            'Méně informací, ale velmi jednoduché',
            'Rychlejší dodání, pokud je vše bez komplikací'
        ]
    },
    {
        id: '2',
        title: 'Standard',
        price: '7000',
        descriptionList: [
            'Obvykle 2 - 4 stránky',
            'Vhodné pro menší firmy a OSVČ',
            'Pro mnoho uživatelů/klientů nejpřehlednější',
            'Normální rychlost dodání'
        ]
    },
    {
        id: '3',
        title: 'Premium',
        price: '11 000',
        descriptionList: [
            'Obvykle 5 a více stránek',
            'Vhodné pro firmy všech velikostí',
            'Velmi přehledné, velké množství informací',
            'Spíše pomalejší rychlost dodání'
        ]
    }
]

type Props = PropsWithChildren<{
    title: string
    price: string
    descriptionList: string[]
}>

const PriceItem: React.FC<Props> = ({ title, price, descriptionList }) => {
    return (
        <S.PriceItem>
            <S.PriceItemHeader>
                <S.PriceItemTitle>{title}</S.PriceItemTitle>
                <S.PriceText>Od {price} Kč</S.PriceText>
            </S.PriceItemHeader>
                <S.DescriptionList>
                    {descriptionList.map((description, index) => (
                        <S.DescriptionText key={index}>{description}</S.DescriptionText>
                    ))}
                </S.DescriptionList>
        </S.PriceItem>
    )
}

const PriceList = () => {
    return (
    <S.PriceList>
        {pricingList.map((item) => (
            <PriceItem key={item.id} title={item.title} price={item.price} descriptionList={item.descriptionList} />
        ))}
    </S.PriceList>
    )
}

export default PriceList